export default "__VITE_ASSET__a78e3a1d__"